import React, { useCallback } from 'react';
import './PostDispatchCancellation.scss';
import { noop } from '../../utils/helper';

function PostDispatchCancellation(props) {
  const {
    userInfo: { telephone } = {},
    view = 'mobile',
    clickHandler = noop,
    dataLocale: {
      CANCELLATION_ICON,
      OKAY,
      PRODUCT_CANCELLATION,
      PRODUCT_SHIPPED_NON_CANCELLEABLE,
      PRODUCT_CANCELLATION_INSTRUCTIONS,
    },
  } = props;
  const clickHandlerFn = useCallback(() => {
    const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
    if (window[trackEnv].LenskartRewamp) {
      window[trackEnv].LenskartRewamp.myaccount?.postDispatchCancelClick({
        ctaname: 'order cancellation popup|ok',
        mobile:
          typeof window !== 'undefined' && typeof window.btoa !== 'undefined'
            ? window.btoa(telephone)
            : '',
      });
    }
    clickHandler();
  }, []);
  return (
    <div
      className={`cancel-container text-center ${view}${
        view === 'desktop' ? ' padding-12' : ' pd-20'
      }`}
      data-testid="cancelContainer"
    >
      <div
        className={`fw700${
          view === 'desktop'
            ? ' fs16 text-color-33 margin-b10'
            : ' fsp16 text-color_grey_black mr-b10'
        }`}
      >
        {PRODUCT_CANCELLATION}
      </div>
      <img
        alt={CANCELLATION_ICON}
        aria-label={CANCELLATION_ICON}
        src="https://static.lenskart.com/media/mobile/universal/assets/cancellation-icon.svg"
      />
      <div
        className={`${
          view === 'desktop'
            ? ' line-height-20 fs14 text-color-33 margin-t16 margin-b16'
            : ' lh-20 fsp14 text-color_grey_black mr-t16 mr-b16'
        }`}
      >
        {PRODUCT_SHIPPED_NON_CANCELLEABLE}
      </div>
      <div
        className={`${
          view === 'desktop'
            ? ' line-height-20 fs14 text-color-33 margin-t16 margin-b16'
            : ' lh-20 fsp14 text-color_grey_black mr-t16 mr-b16'
        }`}
      >
        {PRODUCT_CANCELLATION_INSTRUCTIONS}
      </div>
      <div
        className={`okay-cta inline-block fw700 bora-4 ${
          view === 'desktop'
            ? ' text-color-white cursor-pointer bg-color-primary padding-10 margin-t10'
            : ' text-color_white bg-color_link_blue pd-10 mr-t10'
        }`}
        data-testid="okayCTA"
        onClick={clickHandlerFn}
      >
        {OKAY}
      </div>
    </div>
  );
}

export default PostDispatchCancellation;
